import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, isRef as _isRef, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/contact.png" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " 联系我们 ", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"tooltip\"><div class=\"content\">191-8202-4891</div></div><div class=\"desc phone-number\"><div class=\"img-wrapper\"><img src=\"/assets/phone.svg\"></div><span> 电话联系 </span></div><div class=\"tooltip\"><div class=\"content\">191-8202-4891</div></div><div class=\"desc QR-code\"><div class=\"img-wrapper\"><img src=\"/assets/QRCode.svg\"></div><span> 微信咨询 </span></div><div class=\"tooltip-c\"><div class=\"content\"><img src=\"/assets/code.png\" alt=\"\" srcset=\"\"></div></div>", 5)
const _hoisted_9 = { class: "dialog-footer" }

import TitleBar from '@/components/TitleBar.vue';
import Bottom from '@/components/Bottom.vue';
import { ref, reactive } from 'vue';
import { createComments } from './api/api';
import { ElMessage, ElMessageBox, FormInstance, FormRules, MessageParamsWithType } from 'element-plus';
import SlideVerify, { SlideVerifyInstance } from "vue3-slide-verify";
import "vue3-slide-verify/dist/style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let img1 = require('../public/assets/quantumBg.jpg')
let img2 = require('../public/assets/bank.png') 

class cantactApply {
  commentTitle: string | undefined;
  commentInfo:  string | undefined;
  contactPhone: string | undefined;
}

let smsCodeVisivle       = ref<boolean>(false);
let dialogContactVisible = ref<boolean>(false);
let contactFrom          = ref<any>(new cantactApply);
let vertifyImgs          = [img1,img2]
let formIns              = ref<FormInstance>();
let sliderVertifyIns     = ref<SlideVerifyInstance>();

const contactRules = reactive<FormRules<cantactApply>>({
  commentTitle: [
  {
      required: true,
      message: '请输入留言标题',
      trigger: 'blur',
  },],
  commentInfo: [
  {
    required: true,
    message: '请输入留言内容',
    trigger: 'blur',
  },],
  contactPhone: [
  {
    required: true,
    message: '请输入您的联系方式',
    trigger: 'blur',
  },]
})

function putContact(){
  createComments(contactFrom.value).then((res) => {
    if(res.data.code != 0){
      ElMessage.error(res.data.msg)
      dialogContactVisible.value = false
    } else {
      dialogContactVisible.value     = false;
      contactFrom.value.commentTitle = null;
      contactFrom.value.commentInfo  = null;
      contactFrom.value.contactPhone = null;

      ElMessageBox.alert('提交成功，我们将尽快处理您的请求，并通过短信或者电话的方式联系您。', '提交成功', {
        confirmButtonText: '确认'
      })
    }
  }).catch((error: { message: MessageParamsWithType; }) => {
    ElMessage.error(error.message);
  })
}

function openSmsCode() {
  if(contactFrom.value.contactPhone == null){
    ElMessage.error("联系方式不能为空,请重新填写联系方式");
    return;
  }
  if(contactFrom.value.commentTitle == null){
    ElMessage.error("留言标题不能为空,请再试一次");
    return;
  }
  if(contactFrom.value.commentInfo == null){
    ElMessage.error("留言内容不能为空,请再试一次");
    return;
  }

  formIns.value?.validate((valid) => {
    if(valid) {
      smsCodeVisivle.value = true;
    }
  })
}

function onContact() {
  dialogContactVisible.value = true;
}

function onAgain () {
  sliderVertifyIns.value?.refresh();
};

function onSuccess(times: number) {
  ElMessage.success("验证成功");
  smsCodeVisivle.value = false;
  handleClick()
  putContact()
};

function onFail () {
  ElMessage.error("验证失败请再试一次");
};

function onRefresh() {
  console.log('点击了刷新小图标')
};

// 刷新
function handleClick () {
  sliderVertifyIns.value?.refresh();
};


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleBar),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, { include: "tryout" }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }),
    _createElementVNode("div", { class: "contact-bar" }, [
      _createElementVNode("div", {
        class: "desc",
        onClick: onContact
      }, _hoisted_3),
      _hoisted_4
    ]),
    _createVNode(Bottom),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogContactVisible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(dialogContactVisible) ? (dialogContactVisible).value = $event : dialogContactVisible = $event)),
        title: "在线联系",
        "lock-scroll": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogContactVisible) //@ts-ignore
 ? dialogContactVisible.value = false : dialogContactVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: openSmsCode
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _unref(contactFrom),
            class: "fromContact",
            rules: contactRules,
            ref_key: "formIns",
            ref: formIns
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "留言标题:",
                prop: "commentTitle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "留言标题",
                    modelValue: _unref(contactFrom).commentTitle,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(contactFrom).commentTitle) = $event)),
                    autocomplete: "off",
                    maxlength: "64"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "留言内容:",
                prop: "commentInfo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "留言内容",
                    modelValue: _unref(contactFrom).commentInfo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(contactFrom).commentInfo) = $event)),
                    autocomplete: "off",
                    type: "textarea",
                    autosize: { minRows: 6, maxRows: 12 },
                    maxlength: "512"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "联系方式:",
                prop: "contactPhone"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "联系方式",
                    modelValue: _unref(contactFrom).contactPhone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(contactFrom).contactPhone) = $event)),
                    autocomplete: "off",
                    maxlength: "64"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _unref(smsCodeVisivle),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(smsCodeVisivle) ? (smsCodeVisivle).value = $event : smsCodeVisivle = $event)),
        title: "请验证您的身份",
        width: "500",
        "lock-scroll": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(SlideVerify), {
              class: "silde_box",
              ref_key: "sliderVertifyIns",
              ref: sliderVertifyIns,
              "slider-text": "向右滑动->",
              accuracy: "1",
              w: "450",
              imgs: _unref(vertifyImgs),
              onAgain: onAgain,
              onSuccess: onSuccess,
              onFail: onFail,
              onRefresh: onRefresh
            }, null, 8, ["imgs"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})